<template>
  <q-page>
    <router-view />
  </q-page>
</template>

<script>
export default {
  name: 'PageCoach'
}
</script>
